/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

const React = require("react")
const { HashRouter } = require("react-router-dom")
const { ThemeProvider } = require("next-themes")
const { UserProvider } = require("./src/context/UserContext")
require("./src/styles/global.css")

// next-themes drives `.dark` class on <html> for dark/light only (shadcn standard).
// Density (wide/compact) is an orthogonal [data-density] attribute, not a theme.
// UserProvider 提供全局 user 状态，任何组件可通过 useUser() 读取/更新。
exports.wrapPageElement = ({ element }) => {
  return React.createElement(
    ThemeProvider,
    {
      attribute: "class",
      defaultTheme: "light",
      enableSystem: false,
      enableLongPress: false,
    },
    React.createElement(
      UserProvider,
      null,
      React.createElement(HashRouter, null, element)
    )
  )
}
